export default {
      id: "build-track-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.svg#build-track",
      toString: function () {
        return this.url;
      }
    }